import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TabSelectContainer = styled.div`
  border-radius: 5px;
  background-color: #eee;
  display: flex;
`;

const TabSelect = styled.div`
  border-radius: 5px;
  padding: 5px 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.selected {
    background-color: #0e3e72;
    color: #fff;
  }

  &.disabled {
    cursor: not-allowed !important;
    color: #aaa;
  }

  &:not(.selected) {
    cursor: pointer;
  }

  .header {
    letter-spacing: '.0875em';
    font-size: 1rem;
  }
  .subtitle {
    font-size: 0.7rem;
  }
`;

interface Props {
  selectedMonth: 1 | 6 | 12;
  handleSwitch: (month: 1 | 6 | 12) => void;
  isMonthRestricted?: (month: 1 | 6 | 12) => boolean;
  large?: boolean;
}

const PAY_EVERY_1M = 'pay-every-1m';
const PAY_EVERY_6M = 'pay-every-6m';
const PAY_EVERY_1Y = 'pay-every-12m';

const PlanCardDiscountSwitch: React.FC<Props> = ({
  selectedMonth,
  handleSwitch,
  isMonthRestricted = () => true,
}) => {
  const [t] = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
      }}
    >
      <TabSelectContainer>
        <TabSelect
          className={classNames({
            selected: selectedMonth === 1,
            disabled: isMonthRestricted(1),
          })}
          onClick={() => handleSwitch(1)}
        >
          <div className="header">{t(PAY_EVERY_1M)}</div>
        </TabSelect>
        <TabSelect
          className={classNames({
            selected: selectedMonth === 6,
            disabled: isMonthRestricted(6),
          })}
          onClick={() => handleSwitch(6)}
        >
          <div className="header">{t(PAY_EVERY_6M)}</div>
          <div className="subtitle">{t('buy-6m-cheaper')}</div>
        </TabSelect>
        <TabSelect
          className={classNames({
            selected: selectedMonth === 12,
            disabled: isMonthRestricted(12),
          })}
          onClick={() => handleSwitch(12)}
        >
          <div className="header">{t(PAY_EVERY_1Y)}</div>
          <div className="subtitle">{t('buy-1y-cheaper')}</div>
        </TabSelect>
      </TabSelectContainer>
    </div>
  );
};

export default PlanCardDiscountSwitch;
